import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import Root from "root/Root";
import configureMiddleware from "./configureMiddleware";

const store = configureMiddleware();
const rootElement = document.getElementById("root");

render(
  <AppContainer>
    <Root store={store} />
  </AppContainer>,
  rootElement
);

if (module.hot) {
  module.hot.accept("./root/Root", () => {
    const NextRoot = require("./root/Root").default;
    render(
      <AppContainer>
        <NextRoot store={store} />
      </AppContainer>,
      rootElement
    );
  });
}
